import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AdminLayout from '@/layouts/AdminLayout';
import RequireAuth from '@/router/RequireAuth';
import LoginView from '@/views/auth/LoginView';
import DashboardView from '@/views/dashboard/DashboardView';
import CustomersView from '@/views/customers/CustomersView';
import CustomerDetailView from '@/views/customers/CustomerDetailView';
import CardsView from '@/views/cards/CardsView';
import WebhooksView from '@/views/webhooks/WebhooksView';
import UpstreamErrorLogsView from '@/views/upstream-errors/UpstreamErrorLogsView';
import UpstreamCommLogsView from '@/views/upstream-comm/UpstreamCommLogsView';
import UpstreamCheckView from '@/views/upstream-check/UpstreamCheckView';
import MockSimulateView from '@/views/mock-simulate/MockSimulateView';
import UpstreamReconcileView from '@/views/reconcile/UpstreamReconcileView';
import WalletLedgerView from '@/views/wallet-ledger/WalletLedgerView';
import SessionListView from '@/views/upstream-lab/SessionListView';
import SessionWorkbenchView from '@/views/upstream-lab/SessionWorkbenchView';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginView />} />
        <Route
          element={
            <RequireAuth>
              <AdminLayout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardView />} />
          <Route path="/customers" element={<CustomersView />} />
          <Route path="/customers/:id" element={<CustomerDetailView />} />
          <Route path="/cards" element={<CardsView />} />
          <Route path="/webhooks" element={<WebhooksView />} />
          <Route path="/upstream-errors" element={<UpstreamErrorLogsView />} />
          <Route path="/upstream-comm" element={<UpstreamCommLogsView />} />
          <Route path="/upstream-check" element={<UpstreamCheckView />} />
          <Route path="/wallet-ledger" element={<WalletLedgerView />} />
          <Route path="/reconcile" element={<UpstreamReconcileView />} />
          <Route path="/upstream-lab" element={<SessionListView />} />
          <Route path="/upstream-lab/:sessionId" element={<SessionWorkbenchView />} />
          <Route path="/mock/simulate" element={<MockSimulateView />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
